import { createSlice } from '@reduxjs/toolkit';

/**
 * Redux slice for thermal printer state (Electron desktop only)
 * Manages USB/network thermal printers for desktop app
 */
const ThermalPrintersSlice = createSlice({
  name: 'thermalPrinters',
  initialState: {
    devices: [],
    selected_device: null,
    paper_size: '80mm',
    error: null,
  },
  reducers: {
    /** Sets available thermal printers and selected device */
    setThermalPrinters(state, action) {
      const { printers, selectedPrinter, selectedPaperSize } = action.payload || {};
      state.devices = printers || [];
      state.selected_device = selectedPrinter || null;
      state.paper_size = selectedPaperSize || '80mm';
    },
    /** Sets selected thermal printer device */
    setSelectedThermalPrinterDevice(state, action) {
      state.selected_device = action.payload;
    },
    /** Sets thermal printer paper size */
    setPaperSize(state, action) {
      state.paper_size = action.payload;
    },
  },
});

export const { setThermalPrinters, setSelectedThermalPrinterDevice, setPaperSize } =
  ThermalPrintersSlice.actions;
export default ThermalPrintersSlice.reducer;
